<template>
  <div class="value">
    <div class="number">{{ number }}</div>
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
  import ApiService from '@/services/api/ApiService.js';
  import axios from 'axios';

  export default {
    name: 'Grafico1Valore',
    props: ['value'],
    data() {
      return {
        title: '',
        number: '',
      }
    },
    created() {
      this.title = this.value.attributes.titolo;
      this.number = this.value.attributes.valore;
    },
  }

</script>
